import { createReducer, on } from '@ngrx/store';
import { UnenrolledDeviceApiActions, UnenrolledDeviceViewActions } from './unenrolled-device.actions';
import { adapter, initialState } from './unenrolled-device.state';

export const unenrolledDeviceReducer = createReducer(
  initialState,
  on(UnenrolledDeviceApiActions.unenrolledDevicesLoaded, (state, { unenrolledDevices }) =>
    adapter.upsertMany(unenrolledDevices, state)
  ),
  on(UnenrolledDeviceViewActions.unenrolledDevicesDeleteRequested, (state, { unenrolledDeviceIds }) =>
    adapter.removeMany(unenrolledDeviceIds, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectUnenrolledDeviceIds = selectIds;

export const selectUnenrolledDeviceEntities = selectEntities;

export const selectAllUnenrolledDevices = selectAll;
